import { resolveReturnPath } from "./returnPath";

export function resolveDashboardHomePath(user) {
  const role = String(user?.role || "").trim().toLowerCase();
  const roles = Array.isArray(user?.roles)
    ? user.roles.map((entry) => String(entry || "").trim().toLowerCase())
    : [];

  if (role === "admin" || roles.includes("admin")) {
    return "/dashboard/admin/overview";
  }
  if (role === "tutor" || roles.includes("tutor")) {
    return "/dashboard/tutor/bookings";
  }
  if (role === "parent") {
    return "/dashboard/student/discover";
  }
  return "/dashboard/student/lessons";
}

export function resolvePostAuthPath(user, ...returnCandidates) {
  const remembered = resolveReturnPath(...returnCandidates);
  if (remembered) {
    if (remembered === "/dashboard" || remembered === "/dashboard/") {
      return resolveDashboardHomePath(user);
    }
    return remembered;
  }
  return resolveDashboardHomePath(user);
}

export function isBareDashboardPath(path) {
  const normalized = String(path || "").trim();
  return normalized === "/dashboard" || normalized === "/dashboard/";
}
